import { useRouter } from 'next/router';
import React from 'react';
import {
  FacebookShareButton,
  LinkedinShareButton,
  RedditShareButton,
  TwitterShareButton,
} from 'react-share';

import { UISocial } from '@klappir/types';
import { getColor } from '@klappir/ui/brand';
import { Icon } from '@klappir/ui/icon';
import { Paragraph } from '@klappir/ui/text';
import { rem } from '@klappir/util/styles';
import styled from '@klappir/vendor/styled';

export const StyledShare = styled.div<{ direction?: string }>`
  display: flex;
  gap: 16px;
  flex-direction: ${(props) => props.direction};
  justify-content: flex-end;
  align-items: center;

  grid-area: share;

  color: ${getColor('gray', 80)};

  svg .stroke {
    color: ${getColor('gray', 60)};
  }

  ${Paragraph} {
    font-size: ${rem(16)};
  }

  [aria-label='facebook']:hover svg .stroke {
    stroke: #1877f2;
  }
  [aria-label='linkedin']:hover svg .stroke {
    stroke: #0077b5;
  }
  [aria-label='twitter']:hover svg .stroke {
    stroke: #1da1f2;
  }
  [aria-label='reddit']:hover svg .stroke {
    stroke: #ff4500;
  }
`;

export const Share = ({
  url,
  title,
  description,
  direction = 'row',
  showLabel = true,
}: UISocial.ShareProps) => {
  const { locale } = useRouter();
  return (
    <StyledShare direction={direction}>
      {showLabel ? (
        <Paragraph color={getColor('gray', 60)}>
          {locale === 'is' ? 'Deila grein' : 'Share article'}
        </Paragraph>
      ) : null}
      <FacebookShareButton url={url} quote={description}>
        <Icon id="facebook" width="16" height="16" />
      </FacebookShareButton>
      <LinkedinShareButton url={url} title={title} summary={description}>
        <Icon id="linkedin" width="16" height="16" />
      </LinkedinShareButton>
      <TwitterShareButton url={url} title={title}>
        <Icon id="twitter" width="16" height="16" />
      </TwitterShareButton>
      <RedditShareButton url={url} title={title}>
        <Icon id="reddit" width="16" height="16" />
      </RedditShareButton>
    </StyledShare>
  );
};
